// extracted by mini-css-extract-plugin
module.exports = {"icon":"Soon_icon__2hfIV"};